// extracted by mini-css-extract-plugin
export var addButton = "_b3-0";
export var border = "_b3-8";
export var check = "_b3-h";
export var danger = "_b3-6";
export var dropdownContainer = "_b3-1";
export var editModalBody = "_b3-j";
export var footerContainer = "_b3-i";
export var fullWidth = "_b3-a";
export var hide = "_b3-9";
export var icon = "_b3-3";
export var input = "_b3-7";
export var inputFlex = "_b3-b";
export var inputWrapper = "_b3-c";
export var manualFocus = "_b3-5";
export var optionButton = "_b3-4";
export var pillWrapper = "_b3-e";
export var pointer = "_b3-2";
export var showOverflow = "_b3-f";
export var tagsFlex = "_b3-d";
export var xButton = "_b3-g";